import React from 'react'
import styled from 'styled-components'
import { StyledButton } from '../styles/SharedStyles'
import { MdOutlineDownloadForOffline } from 'react-icons/md'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const ButtonBox = styled.div`
  margin-top: 0.5rem;
`
const DownloadButton = ({ onClick }) => {
  const { t } = useTranslation()
  return (
    <ButtonBox>
      <StyledButton onClick={onClick} className="download">
        <div className="space">{t('download chart')}</div>
        <MdOutlineDownloadForOffline />
      </StyledButton>
    </ButtonBox>
  )
}

export default DownloadButton
